import { z } from 'zod';
export const CommitDTO = z.object({
    sha: z.string(),
    shortSha: z.string(),
    message: z.string(),
    title: z.string(),
    authorName: z.string(),
    authorEmail: z.string(),
    authoredDate: z.string(),
    parents: z.array(z.string()),
    refs: z.array(z.string()).default([]),
});
export const BranchDTO = z.object({
    name: z.string(),
    headSha: z.string(),
    isDefault: z.boolean(),
    isProtected: z.boolean(),
});
export const TagDTO = z.object({
    name: z.string(),
    sha: z.string(),
    message: z.string().nullable(),
});
export const CherryPickEdgeDTO = z.object({
    id: z.string(),
    sourceSha: z.string(),
    targetSha: z.string(),
    note: z.string().nullable(),
    createdByName: z.string(),
    createdAt: z.string(),
});
export const GraphDTO = z.object({
    repoId: z.string(),
    defaultBranch: z.string(),
    branches: z.array(BranchDTO),
    tags: z.array(TagDTO),
    commits: z.array(CommitDTO),
    cherryPicks: z.array(CherryPickEdgeDTO),
});
//# sourceMappingURL=graph.js.map